module.exports = {
  backToMain: 'Back',
  print: 'Print',
  savePDF: 'Save as PDF',
  saveWord: 'Save as Word',
  saveExcel: 'Save as Excel',
  email: 'Email',
  fax: 'Fax',
  company: 'Company',
  emailAddress: 'Email Address',
  cc: 'CC',
  title: 'Title',
  content: 'Content',
  localAgent: 'LocalAgent',
  destinationAgent: 'DestinationAgent',
  designationAgent: 'DesignationAgent',
  customer: 'Customer',
  bookingAgent: 'BookingAgent',
  motorcade: 'Motorcade',
  warehouse: 'Warehouse',
  send: 'Send',
  cancel: 'Cancel',
  tel: 'Tel',
  ok: 'OK',
  faxCode: 'Code',
  faxNo: 'FaxNo',
  faxExt: 'Ext:',
  BlAddress: 'BL Address',
  ShippingCmp: 'Carrier',
  NominatedAgent: 'Nominated Agent',
  PortAgency: 'Agent at port of origin/destination',
  InvokeLocalMailClient: 'Local Mail'
}
